export const MIN_DISPLAYABLE_AVG_RATING = 3.0;

export const CAROUSEL_METADATA_COLLECTION_SLUG = {
  STACKABLE_DEGREES: 'stackable-degrees-metadata',
  STACKABLE_SPECIALIZATIONS: 'stackable-specializations-metadata',
};

export default {};
